module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAhCAYAAADZPosTAAABYElEQVRIid3WTUsbQRgA4CcfnorSHkKgFArm4MV7Lz20afUotWhP+Xf1Ktrc+kkhpJBzgoI/wUoDoUclHnYCmyVmJjYgzcDCuzvv+zDDvLtJ6fHHa5GxhR8hfo2L/OSwVZlKLsc0NPE0XG9iydUE8Bjvc/E/g5fYSchD2pYXGksHU7Zcwl6I2xjPS05Z4T5Ow7UfS36QLZ/gXYjbywDH+JSQh/+hbVLAGr7iO+rLAD/grewjcbgMcC0XRw9xNQ5lxcCqrLde4jP+3gd5cnSzIfuqd6r4hU0MZL32e0Gsjm/YxnkZj8LctuznsraA9wzdUAvrZVn3jwpo9BUL2E80wv0IB2V0sFtAu6FgEWx32Kr0JqfcK6CNUDALvRNjum1S0OcF7Ao7EwxKM/7bvMAXbMxYXX5coTlsVfr5h7Mae7LSPzEM/eLEXW9KD69CYTI2DxQKmgV0LhYD8+gAZzEMbgGN6FDA3t+IRAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiantou3.png
// module id = YzqY
// module chunks = 1